import axios from "axios";

export const getInstallazioniApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/cmms/installazione/`, {
        params: params
    });
}